import styled from 'styled-components';

import { Center } from '../../Center';

export const Wrapper = styled(Center)`
	flex-direction: column;
	width: 100%;
`;
